var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-relook"},[_c('div',{staticClass:"xgPlayer",attrs:{"id":"xgPlayer"}}),_c('div',{staticClass:"button-con",on:{"click":_vm.goMore}},[_c('span',[_vm._v("查看更多精彩内容")])]),_c('get-shop-info',{attrs:{"title":'直播回放'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }